module.exports = __webpack_public_path__ + "0fed0e4a20126c855f54209238aa1415.png";